import React, { useEffect } from 'react';
import LogoFooterImage from '@assets/images/logo-footer.png';

const Footer = () => {
  useEffect(() => {}, []);

  return (
    <footer className="footer" id="footer-contact">
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col-12 col-md-5">
              <div className="logo">
                <img
                  width={300}
                  src={LogoFooterImage}
                  alt="Pyxis Technologies"
                />
              </div>
            </div>
            <div className="col-12 col-md-7">
              <div className="row">
                <div className="col-12 col-md-5">
                  <div className="footer-link">
                    <div className="head">contact</div>
                    <div className="list">
                      <div className="item">
                        <div className="icon">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_3417_4086)">
                              <path
                                d="M9.86331 4.23315C7.84402 4.23315 6.20117 5.876 6.20117 7.8953C6.20117 9.9146 7.84402 11.5574 9.86331 11.5574C11.8826 11.5574 13.5255 9.9146 13.5255 7.8953C13.5255 5.876 11.8827 4.23315 9.86331 4.23315ZM9.86331 10.0155C8.69424 10.0155 7.74311 9.06437 7.74311 7.8953C7.74311 6.72622 8.69424 5.7751 9.86331 5.7751C11.0324 5.7751 11.9835 6.72622 11.9835 7.8953C11.9835 9.06437 11.0324 10.0155 9.86331 10.0155Z"
                                fill="#DE5D2F"
                              />
                              <path
                                d="M9.86348 -0.00708008C5.506 -0.00708008 1.96094 3.53802 1.96094 7.89547V8.11392C1.96094 10.3177 3.2244 12.8858 5.71636 15.7467C7.52283 17.8207 9.30407 19.2669 9.37896 19.3274L9.86348 19.7189L10.348 19.3275C10.4229 19.2669 12.2042 17.8207 14.0106 15.7467C16.5025 12.8858 17.766 10.3177 17.766 8.11396V7.8955C17.766 3.53802 14.221 -0.00708008 9.86348 -0.00708008ZM16.2241 8.11396C16.2241 11.8382 11.4255 16.3465 9.86348 17.7151C8.30108 16.3461 3.50288 11.8379 3.50288 8.11396V7.8955C3.50288 4.38828 6.35626 1.5349 9.86348 1.5349C13.3707 1.5349 16.2241 4.38828 16.2241 7.8955V8.11396Z"
                                fill="#DE5D2F"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_3417_4086">
                                <rect
                                  width="19.726"
                                  height="19.726"
                                  fill="white"
                                  transform="translate(0 -0.00683594)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div className="text">
                          Address: 15897 S Axia Dr, Suite 400, Herriman, UT
                          84065
                        </div>
                      </div>
                      <div className="item">
                        <div className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20px"
                            height="20px"
                            viewBox="0 0 24 24"
                            fill="none">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M3.75 5.25L3 6V18L3.75 18.75H20.25L21 18V6L20.25 5.25H3.75ZM4.5 7.6955V17.25H19.5V7.69525L11.9999 14.5136L4.5 7.6955ZM18.3099 6.75H5.68986L11.9999 12.4864L18.3099 6.75Z"
                              fill="#de5d2f"
                            />
                          </svg>
                        </div>
                        <div className="text">
                          <a href="mailto:contact@pyxistec.com">
                            contact@pyxistec.com
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-7">
                  <div className="follow">
                    <div className="head">Follow to receive news</div>
                    <div className="group-btn">
                      <input placeholder="Your email" />
                      <button>Follow</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="copyright">
            <div className="text">
              © 2025, Pyxis Technologies, All Right Reserved
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
